import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function TermosDeUso() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button variant="ghost" asChild className="mb-4 -ml-2">
          <Link to="/auth">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Link>
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Termos de Uso – Sun7 Link</CardTitle>
            <p className="text-sm text-muted-foreground">
              Última atualização: 22 de fevereiro de 2026
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none dark:prose-invert space-y-6">
            {/* 1. Identificação */}
            <section>
              <h2 className="text-lg font-semibold mb-2">1. Identificação</h2>
              <p>
                Plataforma mantida por:
              </p>
              <p>
                <strong>RST SERVIÇOS DE ENGENHARIA LTDA</strong><br />
                CNPJ 37.395.997/0001-36<br />
                Florianópolis/SC
              </p>
            </section>

            {/* 2. Natureza da Plataforma */}
            <section>
              <h2 className="text-lg font-semibold mb-2">2. Natureza da Plataforma</h2>
              <p>
                O Sun7 Link é uma ferramenta tecnológica destinada exclusivamente ao:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Registro de indicações comerciais</li>
                <li>Acompanhamento do status de propostas e contratos</li>
                <li>Visualização de informações financeiras relacionadas a comissões</li>
              </ul>
              <p className="mt-2">
                A plataforma constitui meio digital de organização de dados, não configurando instrumento de representação comercial.
              </p>
            </section>

            {/* 3. Natureza da Relação com Parceiros */}
            <section>
              <h2 className="text-lg font-semibold mb-2">3. Natureza da Relação com Parceiros</h2>
              <p>O parceiro atua de forma:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Autônoma</li>
                <li>Independente</li>
                <li>Sem subordinação jurídica</li>
                <li>Sem controle de jornada</li>
                <li>Sem metas obrigatórias</li>
                <li>Sem exclusividade</li>
                <li>Sem remuneração fixa</li>
              </ul>
              <p className="mt-2">
                A remuneração é exclusivamente variável, condicionada ao êxito comercial e ao efetivo recebimento de valores pela CONTRATANTE.
              </p>
              <p className="mt-2">
                A utilização da plataforma não configura:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Vínculo empregatício</li>
                <li>Representação comercial (Lei nº 4.886/65)</li>
                <li>Sociedade</li>
                <li>Mandato</li>
                <li>Agência</li>
                <li>Franquia</li>
                <li>Qualquer forma de associação empresarial</li>
              </ul>
            </section>

            {/* 4. Limitação da Atuação do Parceiro */}
            <section>
              <h2 className="text-lg font-semibold mb-2">4. Limitação da Atuação do Parceiro</h2>
              <p>
                A atuação do parceiro limita-se exclusivamente à indicação de potenciais clientes.
              </p>
              <p className="mt-2">O parceiro:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Não possui poderes para negociar condições comerciais</li>
                <li>Não possui poderes para conceder descontos</li>
                <li>Não possui poderes para formalizar contratos</li>
                <li>Não pode assumir obrigações em nome da CONTRATANTE</li>
              </ul>
              <p className="mt-2">
                Eventuais simulações geradas pela plataforma possuem caráter meramente informativo e preliminar, estando sempre sujeitas à validação interna e formalização exclusiva pela CONTRATANTE.
              </p>
            </section>

            {/* 5. Uso da Plataforma */}
            <section>
              <h2 className="text-lg font-semibold mb-2">5. Uso da Plataforma</h2>
              <p>O usuário compromete-se a:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Fornecer informações verídicas</li>
                <li>Não praticar fraudes</li>
                <li>Não manipular registros de comissão</li>
                <li>Manter sigilo de suas credenciais</li>
                <li>Utilizar a plataforma apenas para fins legítimos</li>
              </ul>
            </section>

            {/* 6. Comissões */}
            <section>
              <h2 className="text-lg font-semibold mb-2">6. Comissões</h2>
              <p>As comissões:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>São devidas apenas sobre valores efetivamente recebidos</li>
                <li>São variáveis</li>
                <li>Não possuem garantia mínima</li>
                <li>Podem sofrer compensação em caso de estorno ou cancelamento</li>
              </ul>
              <p className="mt-2">
                Os valores exibidos na plataforma possuem caráter informativo, podendo sofrer ajustes contábeis ou financeiros.
              </p>
            </section>

            {/* 7. Suspensão e Cancelamento */}
            <section>
              <h2 className="text-lg font-semibold mb-2">7. Suspensão e Cancelamento</h2>
              <p>O acesso poderá ser suspenso ou cancelado em caso de:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Violação contratual</li>
                <li>Fraude</li>
                <li>Uso indevido da plataforma</li>
                <li>Descumprimento da legislação aplicável</li>
              </ul>
            </section>

            {/* 8. Propriedade Intelectual */}
            <section>
              <h2 className="text-lg font-semibold mb-2">8. Propriedade Intelectual</h2>
              <p>
                A plataforma, seus códigos, banco de dados, metodologia, layout e marca são de propriedade exclusiva da empresa.
              </p>
            </section>

            {/* 9. Independência entre Plataforma e Contrato */}
            <section>
              <h2 className="text-lg font-semibold mb-2">9. Independência entre Plataforma e Contrato</h2>
              <p>
                A adesão a estes Termos não substitui o Contrato de Parceria Comercial firmado entre as partes.
              </p>
              <p className="mt-2">
                Em caso de conflito, prevalecerá o instrumento contratual formal.
              </p>
            </section>

            {/* 10. Foro */}
            <section>
              <h2 className="text-lg font-semibold mb-2">10. Foro</h2>
              <p>
                Fica eleito o foro da Comarca de Florianópolis/SC para dirimir eventuais controvérsias.
              </p>
            </section>

            <div className="pt-4 border-t">
              <p className="text-sm text-muted-foreground">
                Em caso de dúvidas, entre em contato: R. Belmira Isabel Martins, 42 - Estreito, Florianópolis - SC, 88075-145
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
